<template>
  <el-tabs v-model="activeNav" class="side-nav" tab-position="right">
    <el-tab-pane v-for="(menu, index) in menuList" :key="index">
      <template v-slot:label>
        <div class="nav-label" @click="select(menu, index)">{{ menu.name }}</div>
      </template>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  name: "side-menu",
  props: {
    menuList: Array
  },
  data() {
    return {
      activeNav: "0"
    }
  },
  methods: {
    init() {
      this.activeNav = "0"
    },
    select(menu, index) {
      this.$emit("select", menu)
    }
  }
}
</script>

<style lang="scss" scoped>
.side-nav {
  display: inline-flex;
  margin-top: 62px;
  width: 100%;
  color: $color-font-first;
  ::v-deep {
    .el-tabs__header.is-right {
      float: none;
      width: 100%;
      margin-left: 1px;
    }
    .el-tabs__nav-wrap::after {
      content: "";
      width: 6px !important;
      top: 2px;
      bottom: auto;
      left: 0;
      right: auto;
      border-radius: 4px;
      height: calc(100% - 8px) !important;
    }
    .el-tabs__active-bar {
      width: 6px !important;
      border-radius: 4px;
      background-color: $color-main;
      box-shadow: 0 2px 4px 0 rgba(192, 192, 192, 1);
      height: 26px !important;
    }
    .el-tabs__item {
      display: block;
      overflow: hidden;
      white-space: initial;
      height: auto;
      padding: 0;
      font-size: 16px;
      &.is-active {
        color: $color-main;
      }
      .nav-label {
        padding: 5px 0 10px 18px;
        line-height: 18px;
        font-size: 14px;
      }
    }
  }
}
</style>
